G.BoardFallMgr = function(board, refiller) {
  this.board = board;
  this.boardData = board.boardData;
  this.refiller = refiller;
  this.refillData = [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1];
};

G.BoardFallMgr.prototype.allCollumsFall = function() {

  this.refillData = [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1];

  for (var i = 0; i < this.boardData.width; i++) {
    this.collumnFall(i);
  }

};

G.BoardFallMgr.prototype.collumnFall = function(coll) {
  //start from bottom
  for (var row = this.boardData.height-1; row >= 0; row--) {

    //check if this cell is in board
    if (this.boardData.get(coll,row) == 'X') continue;

    //if there is no candy on cell
    if (!this.board.getCandy(coll,row) && !this.board.boardIce.isToken(coll, row)) { 
      var candyToFall = false;
      //try to find candy above
      for (var rowCheck = row; rowCheck >= 0; rowCheck--) {
        var candyToFall = this.board.getCandy(coll,rowCheck);

        if (this.board.isMoveBlocked(coll, rowCheck) || (candyToFall && candyToFall.isFallingBlocked())) {
          candyToFall = true;
          break;
        }

        if (candyToFall && this.board.isMoveable(coll,rowCheck)) {
          candyToFall.fallTo(coll,row);
          break; 
        }
      }

      //if any candy above was not found make refill
      if (!candyToFall) {
        this.board.newFallingCandy(coll,row,this.refiller.getTypeToDrop(coll),this.refillData[coll]--);
      }
    
    }
  };

};


G.BoardFallMgr.prototype.isCellSolid = function(cellX,cellY) {

  if (cellY == this.boardData.height || this.boardData.get(cellX,cellY) == 'X') return true; 
  return this.board.getCandy(cellX,cellY);
};

G.BoardFallMgr.prototype.crossCollumnFall = function() {

  var self = this;
  var board = this.board;

  var wasAnyCandyMoved = false;
  var val = 1;

  for (var row = this.boardData.height-1; row >= 0; row--) {
    for (var coll = 0; coll < this.boardData.width; coll++) {
      if (isSpaceFreeAndCanMovedTo(coll, row)) {

        if (this.isCellSolid(coll,row+1)) {

          for (var rowToPull = row-1; rowToPull >= 0; rowToPull--) {
            if (tryPullFromTopSide(coll, row, val, rowToPull-row) || tryPullFromTopSide(coll, row, -val, rowToPull-row)) {
              wasAnyCandyMoved = true;
              break;
            }

            if (!isSpaceFreeAndCanMovedTo(coll, rowToPull)) break;
          }
          val *= -1;
        } 
      }
    }
  }

  function getFallingBlockedCandyAbove(x, y) {
    var blockedFall = null;
    for (var row = y; row >= 0; row--) {
      var candy = board.getCandy(x, row);
      if (candy && candy.isFallingBlocked()) {
        return candy;
      }
    }
  }

  function isSpaceFreeAndCanMovedTo(x, y) {
    return board.isCellOnBoard(x, y) 
      && !self.isCellSolid(x, y)
      && !board.isMoveBlocked(x, y);
  }

  function tryPullFromTopSide(x, y, side, verticalOffset) {
    if (board.isMoveable(x+side, y+verticalOffset) && !(board.getCandy(x+side, y+verticalOffset).isFallingBlocked())) {
      board.getCandy(x+side, y+verticalOffset).fallTo(x, y);
      self.collumnFall(x+side);
      return true;
    }
    return false;
  }

  return wasAnyCandyMoved;

};